<div>
  <div class="modal-header">
    <h4 class="modal-title" translate>page.operateurs.informations.modale.titleUpdate.infosMajeures</h4>
  </div>

  <div class="modal-body">
    <form [formGroup]="formCreationOperateur" *ngIf="formCreationOperateur" #form="ngForm" (submit)="onSubmit()">
      <div class="flex">
        <div class="col-6">
          <div class="mb-3">
            <label for="structureJuridique" class="col-form-label" translate>page.operateurs.informations.entreprise.structureJuridique</label>
            <input id="structureJuridique" formControlName="structureJuridique" class="form-control" type="text">
          </div>
          <div class="mb-3">
            <label for="raisonSociale" class="col-form-label" translate>page.operateurs.informations.entreprise.raisonSociale
              <strong>*</strong></label>
            <input id="raisonSociale" formControlName="raisonSociale" class="form-control" type="text">
          </div>
          <div class="mb-3">
            <label for="siret" class="col-form-label" translate>page.operateurs.informations.entreprise.siret
              <strong>*</strong></label>
            <input id="siret" formControlName="siret" class="form-control" type="text"
                   (blur)="onSiretBlur()"
                   [ngClass]="{'is-invalid': siret.invalid && (siret.touched || form.submitted)}">
            <ng-container *ngIf="siret.touched || form.submitted">
              <div *ngIf="siret.errors?.required" class="form-error" translate>page.operateurs.informations.modale.siret</div>
              <div *ngIf="siret.errors?.minlength" class="form-error" translate>page.operateurs.informations.modale.siret</div>
              <div *ngIf="siret.errors?.maxlength" class="form-error" translate>page.operateurs.informations.modale.siret</div>
            </ng-container>
          </div>
          <div class="mb-3">
            <label for="tvaIntracommunautaire" class="col-form-label"
                   translate>page.operateurs.informations.entreprise.tvaIntracommunautaire</label>
            <input id="tvaIntracommunautaire" formControlName="tvaIntracommunautaire" class="form-control" type="text">
          </div>
        </div>
        <div class="col-6">
          <div formGroupName="domaineSpecs">
            <div *ngFor="let spec of domaineSpecs">
              <label class="col-form-label" [for]="spec.code">{{ spec.libelle }}</label>
              <input [id]="spec.code" [formControlName]="spec.code" class="form-control"
                     (blur)="onCviBlur(spec.code)"
                     [ngClass]="{'is-invalid': formCreationOperateur.get('domaineSpecs').get(spec.code).invalid &&
                   (formCreationOperateur.get('domaineSpecs').get(spec.code).touched || form.submitted)}">
              <ng-container *ngIf="formCreationOperateur.get('domaineSpecs').get(spec.code).touched || form.submitted">
                <div *ngIf="formCreationOperateur.get('domaineSpecs').get(spec.code).errors?.required ||
                        formCreationOperateur.get('domaineSpecs').get(spec.code).errors?.minlength ||
                        formCreationOperateur.get('domaineSpecs').get(spec.code).errors?.maxlength" class="form-error"
                     translate>
                  page.operateurs.informations.modale.cvi
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-2 mb-2">
      <div class="flex">
        <div class="col-6">
          <div class="mb-3">
            <label for="nom" class="col-form-label" translate>page.operateurs.informations.entreprise.nom</label>
            <input id="nom" formControlName="nom" class="form-control" type="text">

          </div>
          <div class="mb-3">
            <label class="form-label" for="adresse" translate>page.operateurs.informations.entreprise.adresse</label>
            <input id="adresse" formControlName="adresse" class="form-control" type="text">
          </div>

          <div class="mb-3">
            <label class="form-label" for="ville" translate>page.operateurs.informations.entreprise.ville</label>
            <input id="ville" formControlName="ville" class="form-control" type="text">
          </div>

          <div class="mb-3">
            <label class="form-label" for="pays" translate>page.operateurs.informations.entreprise.pays</label>
            <select id="pays" formControlName="pays" class="form-select">
              <option [value]="null" hidden></option>
              <option *ngFor="let pays of refPays" [ngValue]="pays.id">{{pays.libelle}}</option>
            </select>
          </div>

          <div class="mb-3">
            <label class="form-label" for="telFixe" translate>page.operateurs.informations.entreprise.telephoneFixe</label>
            <input id="telFixe" formControlName="telFixe" class="form-control" type="tel"
                   (input)="formatPhoneNumber('telFixe')" (blur)="formatPhoneNumber('telFixe')">
          </div>
          <div class="mb-3">
            <label class="form-label" for="fax" translate>page.operateurs.informations.entreprise.fax</label>
            <input id="fax" formControlName="fax" class="form-control" type="tel"
                   (input)="formatPhoneNumber('telMobile')" (blur)="formatPhoneNumber('telMobile')">
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label for="prenom" class="col-form-label" translate>page.operateurs.informations.entreprise.prenom</label>
            <input id="prenom" formControlName="prenom" class="form-control" type="text">

          </div>
          <div class="mb-3">
            <label class="form-label" for="codePostal" translate>page.operateurs.informations.entreprise.codePostal</label>
            <input id="codePostal" formControlName="codePostal" class="form-control" type="text">
          </div>

          <div class="mb-3">
            <label class="form-label" for="cedex" translate>page.operateurs.informations.entreprise.cedex</label>
            <input id="cedex" formControlName="cedex" class="form-control" type="text">
          </div>

          <div class="mb-3">
            <label class="form-label" for="email" translate>page.operateurs.informations.entreprise.email</label>
            <input id="email" formControlName="email" class="form-control" type="email"
                   [ngClass]="{'is-invalid': email.invalid && (email.touched || form.submitted)}"
                   (blur)="onEmailBlur()"
                   (input)="onEmailInput()">
            <ng-container *ngIf="email.invalid && (email.touched || form.submitted)">
              <div *ngIf="email.errors?.required" class="form-error" translate>
                page.operateurs.informations.modale.email.required
              </div>
              <div *ngIf="email.errors?.multipleEmails" class="form-error" translate>
                page.operateurs.informations.modale.email.multiple
              </div>
              <div *ngIf="email.errors?.invalidEmail" class="form-error" translate>
                page.operateurs.informations.modale.email.invalid
              </div>
            </ng-container>
          </div>


          <div class="mb-3">
            <label class="form-label" for="telMobile" translate>page.operateurs.informations.entreprise.telephoneMobile</label>
            <input id="telMobile" formControlName="telMobile" class="form-control" type="tel"
                   (input)="formatPhoneNumber('telMobile')" (blur)="formatPhoneNumber('telMobile')">
          </div>

        </div>
      </div>
      <div class="actions-bar">
        <button type="button" (click)="onClose()" class="btn btn-light" translate>label.annuler</button>
        <button type="submit" class="btn btn-primary ms-2" translate>label.valider</button>
      </div>

    </form>
  </div>
</div>

